<template>
  <footer class="footer-container will-transform">
    <div class="footer-group">
      <router-link v-for="item in items" :key="item.url" tag="p" :to="item.url" class="light" v-html="item.title"></router-link>
    </div>
  </footer>
</template>

<script>
  import mixinLanguages from '../mixins/Language'
  export default {
    name: 'siteFooter',
    mixins: [mixinLanguages],
    computed: {
      lang() {
        return this.$store.state.langUrl;
      },
      items() {
        return [
          {title:this.getTranslation('artists'),url:'/00/00'},
          {title:this.getTranslation('venues'),url:'/99/00'},
          {title:this.getTranslation('programme'),url:'/programme'},
          {title:this.getTranslation('saved'),url:'/saved'},
        ];
      }
    },
    watch: {
    },
    data() {
      return {
         langSelect:this.lang
      }
    },
    methods: {
 
    }
  }
</script>

<style lang="scss">
  footer {
    position: fixed;
    width: 100vw;
    background: black;
    bottom:0vh;
    left:0vw;
    will-change: transform;
    transform: translateZ(0);
  }
  .footer-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem 3rem 2rem;
    p {
      color:white;
      padding-bottom: 4px;
    }
    .router-link-active {
      border-bottom:1px solid white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/siteFooter.vue